<template>
  <section class="page">
    <div class="wrapper">
      <h2>What I Provide</h2>
      <p class="words">
        I build various web-based things.
        From web apps, web dashboards, websites, back-end &amp; API servers, and web-based event invitations.
        I have worked on a wide range of projects.
      </p>
      <div class="m-grid">
        <m-card>
          <card-image src="https://firebasestorage.googleapis.com/v0/b/anugerah-rompis.appspot.com/o/Screenshot%202022-07-16%20112359.png?alt=media&token=432885e8-d93b-408d-9c0d-cbe35ec6d214" />
          <card-title>Web sites</card-title>
          <card-text>
            Web sites are the most authoritative online source of information an organization can build.
            The websites I build are both functional, good-looking. It's designed to target large range of devices, and therefore reaches wide range of audience.
          </card-text>
        </m-card>
        <m-card>
          <card-image src="https://firebasestorage.googleapis.com/v0/b/anugerah-rompis.appspot.com/o/dashboard.png?alt=media&token=53702be0-3ea3-4c60-b2e3-29f96d7e06e6"/>
          <card-title>Web apps</card-title>
          <card-text>
            The web can do almost everything that apps can do. That's why I aim to build web apps with great user experience and rich features.
            Whether you want a dashboard that displays information, the app that's going to be the entire business model of your start-up, or just a simple little tool that's gonna make your job easier, I'm here to make it a reality.
          </card-text>
        </m-card>
        <m-card>
          <card-image src="https://firebasestorage.googleapis.com/v0/b/anugerah-rompis.appspot.com/o/invite-example.jpg?alt=media&token=c4bb888f-878f-446e-887b-f3cc79eff8fe" />
          <card-title>Web Invite</card-title>
          <card-text>
            Your special day deserves a special, bespoke invite to show your guests. Web-based invite is an interactive way to notify your loved ones about your celebration or event. They link-up seamlessly with calendar, video meeting and navigation apps.
            Can be used as an alternative for&mdash;or in combination with&mdash;physical invites.
          </card-text>
        </m-card>
        <m-card>
          <card-image src="https://firebasestorage.googleapis.com/v0/b/anugerah-rompis.appspot.com/o/api.png?alt=media&token=6e6e0a88-f9f7-4a21-9584-097022fefa83" />
          <card-title>API Backend</card-title>
          <card-text>
            The API server is the hub of your software architecture. Listening for client requests, grabbing an entries off the database, crunching numbers, sending web pages to clients, and innumerable number of potential tasks.
            The API servers that I build are constructed with performance, security, and ease of maintenance in mind.
          </card-text>
        </m-card>
      </div>
    </div>
    <div class="wrapper">
      <h3>Features</h3>
      <div class="m-grid">
        <m-card>
          <card-title>Progressive Web App</card-title>
          <card-text>These apps look and feel like native apps. They have their own icons in launchers and menus.
            They can access cameras, contacts, geolocation, and many more (if granted permission).
            They can also be configured to work without Internet.
            And they're installed directly from the browser, no need for app stores or installer files.</card-text>
        </m-card>
        <m-card>
          <card-title>Responsive Design</card-title>
          <card-text>
            Each page is designed to look great with good usability, even in the most exotic of devices.
            The pages that I build automatically adjust to whatever screen your users open it in, without the need for different versions.
          </card-text>
        </m-card>
        <m-card>
          <card-title>Federated Authentication</card-title>
          <card-text>
            No need to bother your users with remembering yet another password. Instead, they can use their other accounts to login to your site.
            Supports logging in with Google, Facebook, Instagram, Apple, and many more... along with the more traditional e-mail + password.
          </card-text>
        </m-card>
      </div>
    </div>
  </section>
</template>

<script>
import CardImage from '@/components/Card/CardImage.vue'
import MCard from "../components/Card/MCard.vue"
import CardTitle from '@/components/Card/CardTitle.vue'
import CardText from '@/components/Card/CardText.vue'

export default {
  components: {
    'm-card': MCard,
    'card-image': CardImage,
    'card-title': CardTitle,
    CardText
  }
}
</script>

    CardImage
<style scoped>
.page {
  box-sizing: border-box;
  min-height: 100vh;
  background-color: #121212;
}

.wrapper {
  padding: 2rem;
}
</style>
